// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_9n-0";
export var orangeButton = "_9n-1";